module.exports = __webpack_public_path__ + "static/fonts/Avenir_LT_65_Medium.838e22c6.woff";